//Disable SSR
export const ssr = false;